module.exports = __webpack_public_path__ + "static/media/sa.14408485.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/sa.svg
// module id = 2201
// module chunks = 0